import { Grid } from "@mui/material";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import MxDetailLabelValue from "@rf-l1/page/details/MxDetailLabelValue";

const MainDetailCharacteristics = () => {
  const { characteristics } = usePropertyDetailPage();

  if (!characteristics || characteristics.length === 0) {
    return null;
  }

  return (
    <Grid container gap={3}>
      <Grid item xs={12}>
        <MxDetailSubTitle label="Características de la propiedad" />
      </Grid>
      {characteristics && (
        <Grid container item xs={12} spacing={3} rowSpacing={2}>
          {characteristics.map(characteristic => (
            <Grid item xs="auto">
              <MxDetailLabelValue
                direction="column"
                label={characteristic.extraData?.type!}
                value={characteristic.label}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

export default MainDetailCharacteristics;
